module.exports = __webpack_public_path__ + "static/media/oncology-image1@2x.fb29b148.png";